export const getCourseStatus = (course) => {
    const statuses = {
        'new' : 'Не начат',
        'in_progress' : 'В процессе',
        'finished' : 'Завершен',
        'active' : 'Выдан',
    }

    return statuses[course.status] ?? 'Не выдан';
};